module.exports = __webpack_public_path__ + "static/img/img-home-co-12.b1369b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-12.png
// module id = EoT7
// module chunks = 1